import {useContext} from "react";
import {useGetMyFinishedCourses} from "@/app2/shared/data";
import {LocaleContext, resolveLocale} from "@/app2/shared/contexts";

/**
 * Finished courses for My Progress with localized titles from the API.
 */
export const useFinishedCourses = () => {
	const [{locale}] = useContext(LocaleContext);
	const resolvedLocale = resolveLocale(locale);
	const {data, isLoading, isError, error, refetch} = useGetMyFinishedCourses({
		locale: resolvedLocale,
	});

	return {
		courses: data?.data ?? [],
		totalCount: data?.totalCount ?? 0,
		isLoading,
		isError,
		error,
		refetch
	};
};
